import { Routes } from '@angular/router';
import { DroitsComponent } from './droits.component';

export const DROITS_ROUTES: Routes = [
    {
        path: '',
        component: DroitsComponent,
        data: {
            role: 'ADMIN',
            domaines: ['ANPP'],
            menu: {
                libelle: 'menu.administration-droits',
                icon: 'users'
            }
        }
    }
];
